import { useEffect, useState } from 'react'

import equipmentView from './equipmentView'
import { isEqual, keys } from '../../../utils/javascript'
import { getAddressApi } from '../visualization.api'

const mapView = () => {
  const [mapProps, setMapProps] = useState({
    center: { lat: '', lng: '' },
    zoom: 4,
    zoomDetail: {},
    addressType: 'txt_Country',
  })
  const [equipmentDetails, setEquipmentDetails] = useState({
    isOpen: false,
    data: {},
    selected: {},
  })
  const [isPopupOpen, setIsPopupOpen] = useState({})
  const [searchEquipment, setSearchEquipment] = useState('')
  const {
    formData,
    equipmentData,
    pieChartData,
    equipmentLoader,
    buildingEquipmentDetails,
    brandTotal,
    setFormData,
    getData,
    getEquipmentDataList,
    getPieChartDataList,
    setEquipmentData,
    setPieChartData,
    buildingInfoAPI,
    equipmentInfoAPI,
    getPayload,
    getBrandTotalAPI,
  } = equipmentView()

  useEffect(() => {
    if (
      navigator.geolocation &&
      (!mapProps?.center?.lat || !mapProps?.center?.lng)
    ) {
      navigator.geolocation.getCurrentPosition(position => {
        setMapProps({
          ...mapProps,
          center: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
        })
      })
    }
  }, [])

  const handleZoomChange = async zoom => {
    if (!zoom?.bounds) return

    const ne = zoom.bounds.getNorthEast()
    const sw = zoom.bounds.getSouthWest()
    const boundary = {
      latFrom: sw?.lat(),
      latTo: ne?.lat(),
      lngFrom: sw?.lng(),
      lngTo: ne?.lng(),
    }
    const country = 3
    const state = 6
    const city = 9
    const pincode = 11
    const building = 14

    const zoomLevels = [country, state, city, pincode, building]
    const addressTypes = keys(formData)

    let addressType = 'txt_Country'
    let nextTypeTag = 'txt_Country'

    zoomLevels.forEach((threshold, index) => {
      if (zoom.zoom >= threshold) {
        addressType = addressTypes[index]
        nextTypeTag = addressTypes[index]
      }
    })

    setMapProps({
      ...mapProps,
      zoom: zoom.zoom,
      zoomDetail: zoom,
      addressType: addressType,
    })

    getData({
      currentType: nextTypeTag,
      boundary,
      notStateCityList: false,
    })
  }

  const handleClickPin = ({ value, addressType }) => {
    const currentType = addressType || mapProps?.addressType
    setEquipmentData({})
    setPieChartData({})
    if (!addressType) {
      setEquipmentDetails({ isOpen: false, data: {}, selected: {} })
      setFormData(prev => {
        let updatedState = { ...prev }
        updatedState[currentType].selected = {}
        return updatedState
      })
    }
    setFormData(prev => {
      let updatedState = { ...prev }
      updatedState[currentType].selected = value
      return updatedState
    })

    setTimeout(() => {
      getEquipmentDataList({
        selected: value,
        currentType: currentType,
        notStateCityList: true,
      })
      getPieChartDataList({
        selected: value,
        currentType: currentType,
        notStateCityList: true,
      })
      const equipmentParam = getPayload({
        selected: value,
        type: currentType,
        notStateCityList: true,
      })
      getBrandTotalAPI({ params: equipmentParam })
      if (isEqual(currentType, 'user_Building')) {
        buildingInfoAPI({
          buildingId: value?.id,
        })
      }
    }, 1000)
  }

  const handleSelectEquipment = ({ selectedItem, selectedBuilding }) => {
    equipmentInfoAPI({
      buildingId:
        formData?.['user_Building']?.selected?.id || selectedBuilding?.id,
      equipmentId: selectedItem?.id,
    })
    handleClickPin({ value: selectedItem, addressType: 'txt_Equipment' })
    setEquipmentDetails(prev => ({
      ...prev,
      selected: selectedItem,
    }))
  }

  const handleEquipmentList = async ({ details }) => {
    const params = {
      type: 'EQUIPMENT',
      visualizationType: 'LIST',
      buildingId: details?.buildingDetail?.id,
    }
    const response = await getAddressApi({ params })
    if (response?.data) {
      setEquipmentDetails(prev => ({
        ...prev,
        isOpen: true,
        data: response?.data,
      }))
    } else if (response?.error) {
      //handle error
    }
  }
  const handleClearSelectedEQ = () => {
    setEquipmentDetails(prev => ({
      ...prev,
      selected: {},
    }))
    handleClickPin({
      value: formData?.['user_Building']?.selected,
      addressType: 'user_Building',
    })
  }

  const handleSearchEquipment = e => {
    const { value } = e.target
    setSearchEquipment(value)
  }

  return {
    mapProps,
    isPopupOpen,
    formData,
    equipmentData,
    pieChartData,
    buildingEquipmentDetails,
    searchEquipment,
    equipmentDetails,
    equipmentLoader,
    brandTotal,
    setIsPopupOpen,
    handleZoomChange,
    handleClickPin,
    handleEquipmentList,
    handleSelectEquipment,
    handleClearSelectedEQ,
    handleSearchEquipment,
  }
}

export default mapView
